webpackJsonp([259661066386442],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MediaOverlay = exports.Media = undefined;
	
	var _Media2 = __webpack_require__(120);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MediaOverlay2 = __webpack_require__(121);
	
	var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Media3.default;
	exports.Media = _Media3.default;
	exports.MediaOverlay = _MediaOverlay3.default;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SVGIcon = undefined;
	
	var _SVGIcon2 = __webpack_require__(123);
	
	var _SVGIcon3 = _interopRequireDefault(_SVGIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SVGIcon3.default;
	exports.SVGIcon = _SVGIcon3.default;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PostPreview = __webpack_require__(99);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostListing = function (_React$Component) {
	  _inherits(PostListing, _React$Component);
	
	  function PostListing() {
	    _classCallCheck(this, PostListing);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostListing.prototype.getPostList = function getPostList() {
	    var postList = [];
	    this.props.postEdges.forEach(function (postEdge) {
	      postList.push({
	        path: postEdge.node.fields.slug,
	        tags: postEdge.node.frontmatter.tags,
	        cover: postEdge.node.frontmatter.cover.childImageSharp.sizes,
	        title: postEdge.node.frontmatter.title,
	        date: postEdge.node.frontmatter.date,
	        excerpt: postEdge.node.excerpt,
	        timeToRead: postEdge.node.timeToRead
	      });
	    });
	    return postList;
	  };
	
	  PostListing.prototype.render = function render() {
	    var postList = this.getPostList();
	    return _react2.default.createElement(
	      "div",
	      { className: "md-grid md-grid--no-spacing md-cell--middle" },
	      _react2.default.createElement(
	        "div",
	        { className: "md-grid md-cell--8 mobile-fix" },
	        postList.map(function (post) {
	          return _react2.default.createElement(_PostPreview2.default, { key: post.title, postInfo: post });
	        })
	      )
	    );
	  };
	
	  return PostListing;
	}(_react2.default.Component);
	
	exports.default = PostListing;
	module.exports = exports["default"];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(68);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardTitle = __webpack_require__(53);
	
	var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	var _Buttons = __webpack_require__(67);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Avatars = __webpack_require__(114);
	
	var _Avatars2 = _interopRequireDefault(_Avatars);
	
	var _CardText = __webpack_require__(52);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _FontIcons = __webpack_require__(54);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Media = __webpack_require__(122);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _PostTags = __webpack_require__(138);
	
	var _PostTags2 = _interopRequireDefault(_PostTags);
	
	__webpack_require__(109);
	
	var _SVGIcons = __webpack_require__(71);
	
	var _SVGIcons2 = _interopRequireDefault(_SVGIcons);
	
	var _gatsbyImage = __webpack_require__(49);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrowDown = function ArrowDown(props) {
	  return _react2.default.createElement(
	    "svg",
	    { height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement("path", { d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" }),
	    _react2.default.createElement("path", { d: "M0-.75h24v24H0z", fill: "none" })
	  );
	};
	
	var PostPreview = function (_Component) {
	  _inherits(PostPreview, _Component);
	
	  function PostPreview(props) {
	    _classCallCheck(this, PostPreview);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      mobile: true
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  PostPreview.prototype.componentDidMount = function componentDidMount() {
	    this.handleResize();
	    window.addEventListener("resize", this.handleResize);
	  };
	
	  PostPreview.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.handleResize);
	  };
	
	  PostPreview.prototype.handleResize = function handleResize() {
	    if (window.innerWidth >= 640) {
	      this.setState({ mobile: false });
	    } else {
	      this.setState({ mobile: true });
	    }
	  };
	
	  PostPreview.prototype.render = function render() {
	    var postInfo = this.props.postInfo;
	    var mobile = this.state.mobile;
	
	    var expand = mobile;
	    /* eslint no-undef: "off"*/
	    var cover = postInfo.cover ? ("") + postInfo.cover : postInfo.cover.startsWith("/");
	    var coverHeight = mobile ? 162 : 225;
	    return _react2.default.createElement(
	      _Card2.default,
	      {
	        key: postInfo.path,
	        raise: true,
	        className: "md-grid md-cell md-cell--4",
	        expanderIcon: _react2.default.createElement(ArrowDown, null) },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: { textDecoration: "none" }, to: postInfo.path },
	        _react2.default.createElement(
	          _Media2.default,
	          {
	            style: {
	              height: coverHeight + "px"
	            },
	            className: "post-preview-cover"
	          },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: postInfo.cover })
	        ),
	        _react2.default.createElement(_CardTitle2.default, { title: postInfo.title })
	      ),
	      _react2.default.createElement(_CardTitle2.default, {
	        avatar: _react2.default.createElement(_Avatars2.default, { icon: _react2.default.createElement(_FontIcons2.default, { iconClassName: "fa fa-calendar" }) }),
	        title: "\u0646\u0634\u0631 \u0641\u064A " + postInfo.date,
	        subtitle: postInfo.timeToRead + " \u062F\u0642\u0627\u0626\u0642 \u0642\u0631\u0627\u0621\u0629",
	        className: "meta-wrapper"
	      })
	    );
	  };
	
	  return PostPreview;
	}(_react.Component);
	
	exports.default = PostPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(49);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _PostListing = __webpack_require__(98);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SEO = __webpack_require__(139);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(20);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Articles = function (_React$Component) {
	  _inherits(Articles, _React$Component);
	
	  function Articles() {
	    _classCallCheck(this, Articles);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Articles.prototype.render = function render() {
	    console.log(this.props);
	    var postEdges = this.props.data.articles.edges;
	    return _react2.default.createElement(
	      "div",
	      { className: "articles-container" },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "\u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A - ",
	          _SiteConfig2.default.siteTitle
	        ),
	        _react2.default.createElement("link", { rel: "canonical", href: "" + _SiteConfig2.default.siteUrl })
	      ),
	      _react2.default.createElement(_SEO2.default, { postEdges: postEdges }),
	      _react2.default.createElement(_PostListing2.default, { postEdges: postEdges })
	    );
	  };
	
	  return Articles;
	}(_react2.default.Component);
	
	exports.default = Articles;
	
	/* eslint no-undef: "off"*/
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-articles-jsx-ad2697e333f37b55cd08.js